import { createIconComponent } from '../../factory/create-icon-component';
export const TurkeyIcon = createIconComponent(
  'TurkeyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28267)">
      <path d="M22.9999 5H0.999878V20H22.9999V5Z" fill="#D80027" />
      <path
        d="M11.6223 10.7767L12.3783 11.8423L13.6026 11.4362L12.8455 12.5008L13.6014 13.5662L12.3775 13.1587L11.6203 14.2233L11.6211 12.9069L10.3972 12.4993L11.6215 12.0932L11.6223 10.7767Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.55898 15.1632C8.12086 15.1632 6.95499 13.9708 6.95499 12.5C6.95499 11.0292 8.12086 9.83676 9.55898 9.83676C10.0074 9.83676 10.4293 9.95273 10.7976 10.1569C10.2198 9.57888 9.42952 9.22217 8.55747 9.22217C6.78746 9.22217 5.3526 10.6897 5.3526 12.4999C5.3526 14.3102 6.7875 15.7777 8.55747 15.7777C9.42952 15.7777 10.2198 15.421 10.7976 14.843C10.4293 15.0472 10.0074 15.1632 9.55898 15.1632Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28267">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
